/* Copyright (c) 2025 Xperi. All Rights Reserved. */

export const ON_SET_FILTERED_GUIDE_SELECTED_ROW = 'ON_SET_FILTERED_GUIDE_SELECTED_ROW';
export const ON_SET_FILTERED_GUIDE_SELECTED_ROW_PREVIEW =
    'ON_SET_FILTERED_GUIDE_SELECTED_ROW_PREVIEW';
export const ON_REPAINT_FILTERED_GUIDE = 'ON_REPAINT_FILTERED_GUIDE';
export const ON_SET_FILTERED_GUIDE_TURBO_SCROLL = 'ON_SET_FILTERED_GUIDE_TURBO_SCROLL';
export const ON_SET_GHOST_MODE_FILTERED_GUIDE = 'ON_SET_GHOST_MODE_FILTERED_GUIDE';
export const ON_SET_CARET_VISIBILITY_FILTERED_GUIDE = 'ON_SET_CARET_VISIBILITY_FILTERED_GUIDE';
export const ON_UPDATE_LAST_REFETCH_TIMESTAMP = 'ON_SET_LAST_REFETCH_TIMESTAMP';
export const ON_SET_NULL_REFETCH_TIMESTAMP = 'ON_SET_NULL_REFETCH_TIMESTAMP';
export const ON_FILTERED_GUIDE_API_ERROR = 'ON_FILTERED_GUIDE_API_ERROR';
